<template>
  <div class="lg:pl-4">
    <div class="lg:flex lg:items-center">
      <div class="text-lg mr-8">Client List</div>

      <div class="mt-4 lg:mt-0">
        <a href="#"
          @click.prevent="$modal.show('add-client-modal')"
          class="text-white bg-blue-500 hover:bg-blue-600 rounded-sm font-semibold no-underline text-xs py-2 px-3">+ New Client</a>


        <a href="#"
          @click.prevent="exportAsCsv"
          v-if="numClients > 0"
          class="text-white bg-gray-600 hover:bg-gray-700 rounded-sm ml-2 font-semibold no-underline text-xs py-2 px-3">Export as a CSV</a>

<!--         <a href="https://m5.connective.com.au/mercury5/"
          v-if="showMercuryOption"
          target="_blank"
          class="text-white bg-green-500 hover:bg-green-600 rounded-sm ml-2 font-semibold no-underline text-xs py-2 px-3">Go to Mercury</a> -->
      </div>
    </div>

    <template v-if="clients == null"></template>

    <template v-else>
      <template v-if="clients.length == 0">
        <div class="text-center mt-12 inline-block w-56">
          <img src="/static/img/icons/icons8-unfriend_male_filled.png" class="w-12 inline" />
          <div class="text-base text-gray-600">
            No clients found. 
          </div>
        </div>
      </template>

      <template v-else>
        <div class="invisible lg:visible hidden lg:block">
          <table class="bp-table mt-4">
            <thead>
              <tr class="border-b border-t border-gray-400">
                <th class="py-4 px-6 text-left border-r">
                  <div class="flex items-center justify-between">
                    Name

                    <OrderByArrow 
                      :updateOrderBy="updateOrderBy"
                      orderKey="applicant_names"
                      orderKeyLabel="applicant name"
                      :orderBy="params.orderBy"
                      :orderType="params.orderType" />
                  </div>
                </th>

                <th class="p-4 text-left border-r">
                  <div class="flex items-center justify-between">
                    Email

                    <OrderByArrow 
                      :updateOrderBy="updateOrderBy"
                      orderKey="applicant_emails"
                      orderKeyLabel="email"
                      :orderBy="params.orderBy"
                      :orderType="params.orderType" />
                  </div>
                </th>

                <th class="p-4 text-left border-r">
                  <div class="flex items-center justify-between">
                    Mobile

                    <OrderByArrow 
                      :updateOrderBy="updateOrderBy"
                      orderKey="mobile_phones"
                      orderKeyLabel="mobile"
                      :orderBy="params.orderBy"
                      :orderType="params.orderType" />
                  </div>
                </th>

                <th class="p-4 text-center border-r">
                  # Docs received / requested
                </th>

                <th class="p-4 text-left border-r">
                  <div class="flex items-center justify-between">
                    Last activity

                    <OrderByArrow 
                      :updateOrderBy="updateOrderBy"
                      orderKey="last_activity_timestamp"
                      :orderBy="params.orderBy"
                      :orderType="params.orderType" />
                  </div>
                </th>

                <th class="py-4 pl-4 pr-3 text-left border-r">
                  <div class="flex items-center justify-between">
                    Status

                    <OrderByArrow 
                      :updateOrderBy="updateOrderBy"
                      orderKey="status"
                      :orderBy="params.orderBy"
                      :orderType="params.orderType" />
                  </div>
                </th>

                <th class="p-4 text-left border-r">
                  <div class="flex items-center justify-between">
                    Access

                    <OrderByArrow 
                      :updateOrderBy="updateOrderBy"
                      orderKey="client_token_created_at"
                      orderKeyLabel="login"
                      :orderBy="params.orderBy"
                      :orderType="params.orderType" />
                  </div>
                </th>

                <th class="p-4 text-center">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <ClientListItemDesktop
                v-for="(client, index) in clients"
                :client="client"
                :index="index"
                :key="'d-' + client.id" />
            </tbody>
          </table>
        </div>


        <div class="visible lg:invisible block lg:hidden mt-4">
          <ClientListItemMobile
            v-for="(client, index) in clients"
            :client="client"
            :index="index"
            :key="'m-' + client.id" />
        </div>

        <div class="my-6 flex justify-between">
          <div class="flex items-center">
            <v-pagination 
              v-if="numClients > params.limit"
              v-model="currentPage"
              :page-count="Math.ceil(numClients / params.limit)"
              :labels="customLabels" />
          </div>

          <div class="mr-4 text-gray-600">
            Found {{ numClients }} {{ numClients == 1 ? 'client' : 'clients' }}
          </div>
        </div>

        <ClientActions
          v-if="openClientActions"
          :client="selectedClient"></ClientActions>
      </template>
    </template>
  </div>
</template>

<script>
  import ClientListItemDesktop  from "./ClientListItemDesktop"
  import ClientListItemMobile   from "./ClientListItemMobile"
  import ClientActions          from './ClientActions'
  import { EventBus }           from '@/shared/event-bus'
  import OrderByArrow           from '@/shared/components/OrderByArrow'
  import vPagination            from 'vue-plain-pagination'

  export default {

    components : {
      ClientListItemDesktop,
      ClientListItemMobile,
      ClientActions,
      OrderByArrow,
      vPagination
    },

    data () {
      return {
        clients          : null,
        numClients       : null,
        
        currentPage : 1,
        customLabels: {
          first: false,
          prev: 'Previous',
          next: 'Next',
          last: false
        },
        
        selectedClient   : null,
        openClientActions: false,
        
        params           : {},
      }
    },

    watch: {
      '$route' : {
        immediate: true,
        handler  : function(to, from) {
          if(Object.keys(to.params).length == 0) {
            this.resetParams()
          }

          else {
            this.setParams(to.params)
          }

          this.getClients()
        }
      },

      'currentPage' : {
        handler(to, from) {
          EventBus.$emit('param-changed', {
            key  : 'offset',
            value: this.params.limit * (to-1)
          })
        }
      }
    },

    mounted() {
      EventBus.$on('open-client-actions', selectedClient => {
        this.openClientActions = true
        this.selectedClient    = selectedClient
      });

      EventBus.$on('close-client-actions', () => {
        this.openClientActions = false
        this.selectedClient    = null
      });

      EventBus.$on('reset-params', () => {
        this.resetParams()
        this.$router.push({
          name   : 'client-list-search',
          params : this.params
        });
      });

      EventBus.$on('fetch-clients', () => {
        this.getClients()
      });


      EventBus.$on('param-changed', (keyValue) => {

        // what if we are resetting query
        if(keyValue.key == 'query' && (keyValue.value == null || keyValue.value.length == 0)) {
          keyValue.value = ZmM4rtgJE8
        }

        this.params[keyValue.key] = keyValue.value
        this.$router.push({
          name   : 'client-list-search',
          params : this.params
        });
      })

      EventBus.$on('update-client-note', (params) => {
        this.updateClientNote(params)
      })
    },

    methods: {

      setParams(params) {

        // this is when we landed on the page and then clicked on
        // any search params to start a search
        if(params && Object.keys(params).length > 0) {
          this.params = params
        }

        // this is when we land directly on a particular search params
        else if(Object.keys(this.$route.params).length > 0) {
          this.params = this.$route.params
        }
      },

      resetParams() {
        this.params = {
          query         : this.$store.state.emptyQueryIndicator,
          clientType    : "active",
          status        : "all",
          access        : "all",
          primaryReason : "all",
          firstHomeBuyer: "all",
          clientSource: "all",
          orderBy       : "last_activity_timestamp",
          orderType     : "desc",
          limit         : 30,
          offset        : 0
        }
      },

      getClients() {
        this.showLoader("Loading clients...")
        this.apiGet(this.params, 'client/list', (data) => {
          this.hideLoader()
          this.clients    = data.clients
          this.numClients = data.total          
        })
      },

      // whenever someone clicks on the table header, we will update the ordering
      // of the table
      // But what if we clicked on the same header that we are already ordering by?
      // in that case, we are simply swapping from either ascending to descending or
      // vice versa
      updateOrderBy(orderBy) {
        if(this.params.orderBy == orderBy) {
          this.params.orderType = this.params.orderType == 'asc' ? 'desc' : 'asc'
        } else {
          this.params.orderBy = orderBy
        }

        this.getClientsAndUpdateRoute()
      },

      // paginate(pageNum) {
      //   this.params.offset = this.params.limit * (pageNum-1)
      //   this.getClientsAndUpdateRoute()
      // },

      // each time the search parameter changes
      // we need to update the params on the store
      // and also update the route to reflect the changes
      // so that whenever user refreshes the URL, they are
      // landed on the same page
      // This method is usually accessed from the client list page
      getClientsAndUpdateRoute() {

        // and let's refresh the route to reflect the new change
        this.$router.push({
          name   : 'client-list-search',
          params : this.params
        });

        // let's re-fetch the clients
        this.getClients()
      },

      // addNewClient() {
      //   EventBus.$emit('add-new-client')
      // },

      // whichAddNewClient() {
      //   this.$modal.show('add-client-modal')
      //   // }

      //   // else {
      //   //   this.addNewClient()
      //   // }
      // },

      exportAsCsv() {
        if(this.$store.state[this.$store.state.view + 'Module'].broker.suspended) {
          this.showSuspendedModal()
        }

        else {
          let urlParams = "?token=" + this.getJwt;
          for(let key in this.params) {
            let value = this.params[key]

            // when exporting we don't want to limit
            if(key == 'limit') {
              value = -1
            }

            urlParams += "&" + key + "=" + encodeURIComponent(value)
          }

          // finally add the token and then go to the API endpoint
          window.open(this.getBackendHost + '/api/client/export' + urlParams, '_blank')
        }
      },

      updateClientNote(params) {
        for(let i=0; i < this.clients.length; i++) {
          if(this.clients[i].id == params.clientId) {
            this.clients[i].notes = params.notes
          }
        }
      }
    }
  }
</script>